export default (email, saml = false) => {
  if (saml) {
    return email.substring(0, email.lastIndexOf("@"));
  }
  return email;
};
